import { ADDRESS_FIELD_NAMES } from "../../Forms/PurchaseForm/PurchaseConstants"
import TextInputField from "../TextInputField/TextInputField"

export const AddressInputFieldGroup = (props: {
  fieldName?: string,
  errors: any,
  touched: any,
  message?: string,
  disableFields?: {
    address?: boolean,
    address2?: boolean,
    city?: boolean,
    state?: boolean,
    county?: boolean,
    zip?: boolean
  },
  fieldMessages?: {
    address?: string,
    address2?: string,
    city?: string,
    state?: string,
    county?: string,
    zip?: string
  }
  fieldLabels?: {
    address?: string,
    address2?: string,
    city?: string,
    state?: string,
    county?: string,
    zip?: string
  }
  showCounty?: boolean
}) => {
  const {
    fieldName,
    errors,
    touched,
    message,
    disableFields,
    fieldMessages,
    fieldLabels = {},
    showCounty = false
  } = props
  return (
    <>
      <TextInputField
        fieldName={`${fieldName ? `${fieldName}.` : ''}address`}
        fieldLabel={fieldLabels.address || ADDRESS_FIELD_NAMES.address}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={ADDRESS_FIELD_NAMES.address}
      />

      <TextInputField
        fieldName={`${fieldName ? `${fieldName}.` : ''}address2`}
        fieldLabel={fieldLabels.address2 || ADDRESS_FIELD_NAMES.address2}
        errors={errors}
        touched={touched}
        placeholder={ADDRESS_FIELD_NAMES.address2}
      />

      <TextInputField
        fieldName={`${fieldName ? `${fieldName}.` : ''}city`}
        fieldLabel={fieldLabels.city || ADDRESS_FIELD_NAMES.city}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={ADDRESS_FIELD_NAMES.city}
      />

      <TextInputField
        fieldName={`${fieldName ? `${fieldName}.` : ''}state`}
        fieldLabel={fieldLabels.state || ADDRESS_FIELD_NAMES.state}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={ADDRESS_FIELD_NAMES.state}
        disabled={disableFields?.state}
        fieldSubLabel={fieldMessages?.state}
      />

      <TextInputField
        fieldName={`${fieldName ? `${fieldName}.` : ''}zip`}
        fieldLabel={fieldLabels.zip || ADDRESS_FIELD_NAMES.zip}
        errors={errors}
        touched={touched}
        required={true}
        placeholder={ADDRESS_FIELD_NAMES.zip}
      />

      {showCounty && (
        <TextInputField
          fieldName={`${fieldName ? `${fieldName}.` : ''}county`}
          fieldLabel={fieldLabels.county || ADDRESS_FIELD_NAMES.county}
          errors={errors}
          touched={touched}
          required={true}
          placeholder={ADDRESS_FIELD_NAMES.county}
        />
      )}
    </>
  )
}
